<nav class="sidebar" [class.sidebar--collapsed]="collapsed()" role="navigation" aria-label="Menu principal">
  <a class="sidebar__logo" routerLink="/">
    <app-icon src="icons/sidebar/logo_alterna.svg" alt="Logo" [width]="34" [height]="45" />
  </a>

  <div class="sidebar__nav">
    @for (item of navItems; track item.path) {
      <a [routerLink]="item.path" routerLinkActive="active" #rla="routerLinkActive">
        <app-nav-item [icon]="item.icon" [label]="item.label | transloco" [active]="rla.isActive" />
      </a>
    }
  </div>

  <div class="sidebar__footer">
    <app-icon-button
      class="collapse-icon"
      [class.collapse-icon--flipped]="collapsed()"
      icon="icons/sidebar/collapse_icon.svg"
      [label]="'nav.collapse' | transloco"
      (click)="toggleCollapse()"
    >
    </app-icon-button>
    @if (user()) {
      <app-user-card [name]="user()!.name" [role]="user()!.role" (settingsClick)="logout()" />
    }
  </div>
</nav>
